import { render, staticRenderFns } from "./wrapper-common-component.vue?vue&type=template&id=dddd543a&scoped=true&"
import script from "./wrapper-common-component.vue?vue&type=script&lang=ts&"
export * from "./wrapper-common-component.vue?vue&type=script&lang=ts&"
import style0 from "./wrapper-common-component.vue?vue&type=style&index=0&id=dddd543a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dddd543a",
  null
  
)

export default component.exports